import AabLink from './AabLink';

customElements.define('aab-link', AabLink);
